import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const messageCard = css`
  padding-right: ${rem(30)};
`

export const styles = {
  messageCard,
}
